export default class UserUtils{
  // Security Level
  public static SECURITY_LEVEL_ADMIN = 4
  public static SECURITY_LEVEL_MANAGER = 3
  public static SECURITY_LEVEL_SALES = 2
  public static SECURITY_LEVEL_APPUSER = 1
  public static SECURITY_LEVEL_CLIENT = 0

  public static SECURITY_LEVEL_ARRAY = [
    { idLevel: this.SECURITY_LEVEL_CLIENT, level: "Client" },
    { idLevel: this.SECURITY_LEVEL_APPUSER, level: "Application User" },
    { idLevel: this.SECURITY_LEVEL_SALES, level: "Sales Person" },
    { idLevel: this.SECURITY_LEVEL_MANAGER, level: "Manager" },
    { idLevel: this.SECURITY_LEVEL_ADMIN, level: "Administrator" }
  ]

  public static USERROLE_SALESPERSON = 1
  public static USERROLE_EMPLOYER = 2

  public static getLevelName(idLevel:number){
    let item = this.SECURITY_LEVEL_ARRAY.find(lvl => lvl.idLevel == idLevel)
    return item?.level
  }

}
